import React from "react";

const About = () => {
  return (
    <section className="bg-[#C8F1F9] text-gray-800 px-6 py-16">
      <div className="max-w-6xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-14">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#3498db] mb-4">
            Welcome to Study Partners
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A student-focused learning platform built to make studying smarter,
            easier, and more collaborative.
          </p>
        </div>

        {/* Intro */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-14">
          <p className="text-lg leading-relaxed text-gray-700 mb-6">
            <strong>Study Partners</strong> is a student-focused learning platform
            owned and managed by <strong> Urmila  Chouhan</strong>. It is dedicated to
            bringing learners together to support better understanding, stronger
            motivation, and consistent academic growth.
          </p>

          <p className="text-lg leading-relaxed text-gray-700 mb-6">
            We believe that learning becomes easier, faster, and more enjoyable
            when students study together. A study partner acts as a motivator,
            helper, guide, and trainer — helping each learner stay focused and
            confident on their journey.
          </p>

          <p className="text-lg leading-relaxed text-gray-700">
            Today, Study Partners is recognized as one of the most trusted
            student-focused learning platforms in India and serves as a milestone
            in collaborative education.
          </p>
        </div>

        {/* Power of Studying Together */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center text-[#3498db] mb-8">
            The Power of Studying Together
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow-lg p-6 text-center">
              <p className="text-xl font-semibold text-[#3498db] mb-2">
                Study Alone
              </p>
              <p className="text-gray-600">
                You remember only about <strong>20%</strong> of what you study.
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-6 text-center">
              <p className="text-xl font-semibold text-[#3498db] mb-2">
                Study with a Partner
              </p>
              <p className="text-gray-600">
                Through discussion, you can remember up to <strong>70%</strong>.
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-6 text-center">
              <p className="text-xl font-semibold text-[#3498db] mb-2">
                Teach Each Other
              </p>
              <p className="text-gray-600">
                Teaching helps you retain nearly <strong>90%</strong> of concepts.
              </p>
            </div>
          </div>

          <p className="text-center mt-8 text-lg font-medium text-gray-700">
            Studying together is more than <strong>four times</strong> more
            effective than studying alone.
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-16">
          <div className="bg-white rounded-3xl shadow-xl p-8">
            <h3 className="text-2xl font-bold text-[#3498db] mb-4">
              Our Mission
            </h3>
            <p className="text-gray-700 leading-relaxed">
              To empower students to achieve success in their lives by making
              learning collaborative, accessible, and effective — connecting
              learners who share similar goals and study interests.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-8">
            <h3 className="text-2xl font-bold text-[#3498db] mb-4">
              Our Vision
            </h3>
            <p className="text-gray-700 leading-relaxed">
              To build a strong student community where learning together becomes
              the norm and every learner feels supported, motivated, and
              confident.
            </p>
          </div>
        </div>

        {/* Problem & Solution */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-16">
          <h3 className="text-2xl font-bold text-center text-[#3498db] mb-8">
            The Problem We Solved
          </h3>

          <p className="text-lg text-gray-700 mb-4">
            Previously, students faced a major challenge — there was no dedicated
            platform to find the right study partner who shared similar academic
            goals and interests.
          </p>

          <p className="text-lg text-gray-700">
            Study Partners solves this problem by allowing students to discover,
            connect, and collaborate with the most suitable study partners,
            creating a focused and supportive learning environment.
          </p>
        </div>

        {/* Who Can Use */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-16">
          <h3 className="text-2xl font-bold text-center text-[#3498db] mb-6">
            Who Can Use Study Partners?
          </h3>

          <p className="text-lg text-gray-700 text-center">
            Study Partners is suitable for school students (from Class 9
            onwards), college students, and learners preparing for academic or
            competitive examinations.
          </p>
        </div>

        {/* Ownership */}
        <div className="text-center">
          <h3 className="text-3xl font-bold  text-[#3498db]  mb-2">
            Ownership
          </h3>
          <p className="text-1xl text-gray-700">
            Study Partners is owned and managed by
          </p>
          <p className="text-5xl font-semibold mt-2">
            Urmila Chouhan
          </p>
          <p className="text-gray-600 mt-3">
            Founder & Owner, Study Partners
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
